const MODULE = {
    ADMIN_DASHBOARD: 1,
    CLIENTS: 2,
    PARTNERS: 3,
    PRICING: 4,
    PROMO_CODE: 5,
    ADMIN_REPORTS: 6,
    ADMIN_USER_MANAGEMENT: 7,
    ADMIN_TEMPLATES: 8,
    ADMIN_MARKETPALCE: 9,
    ADMIN_HELP: 10,
    ADMIN_PROFILE: 11,

    DASHBOARD: 15,
    DATABASE_MANAGEMENT: 16,
    LEADS_LISTING: 17,
    LEAD_PROFILE: 18,
    CLIENT_TEMPLATES: 19,
    BEHAVIOUR_MONITORING: 20,
    AUTO_RESPONSE_COMMUNICATION: 21,
    MARKETING_COMMUNICATION: 22,
    SUB_ACCOUNT: 23,
    USER_MANAGEMENT: 24,
    INTEGRATION: 25,
    REPORTS: 26,
    PROFILE: 27,
    HELP: 28,

    PARTNER_DASHBOARD: 29,
    MANAGE_REFERRAL_CLIENT: 32,
    PARTNER_REPORTS: 31,
    VIEW_PARTNER_PROFILE: 30,
    GENERATE_LINK: 33,
    PARTNER_USER_MANAGEMENT: 33,
    MARKET_PLACE: 35,
    SETTING: 34,
    ALTAIRDASHBOARD: 36,
    CHANGEPASSWORD: 37,
    CHANGE_PLANE: 38,
    ALTAIR_USER_MANAGEMENT: 39,

}

const SUBMODULE = {
    ADMIN_TU_MONITORING: 1,
    ADMIN_COMMUNICATION_MONITORING: 2,
    CLIENTS_LISTING: 3,
    CLIENT_PROFILE: 4,
    PARTNERS_LISTING: 5,
    PRICING: 6,
    PROMOTIONS: 7,
    ADMIN_REPORTS: 8,
    ADMIN_HELP: 9,
    ADMIN_TEMPLATES: 10,
    ADMIN_USER_MANAGEMENT: 11,
    ADMIN_CHANGE_PASSWORD: 12,
    ADMIN_ACCESS_LOG: 13,
    ADMIN_MARKET_PLACE: 14,

    CLIENT_TU_MONITORING: 15,
    CLIENT_COMMUNICATION_MONITORING: 16,
    ADD_DATABASE_MANAGEMENT: 17,
    CREDIT_MONITORING: 50,
    PRE_MOVER: 56,
    PRE_MOVER_CONTACT: 57,
    PRE_MOVER_LIST: 58,
    NEW_MOVER: 59,
    NEWLY_MARRIED: 60,
    NEWLY_SINGLE: 61,
    PRENATAL: 62,
    NEW_BABY: 63,
    MORTGAGE_INTENT: 64,
    NEWLY_ENGAGED: 65,

    ACQUISITION: 18,
    RETENTION: 19,
    PROFILE_INFO: 20,
    CLIENT_CHANGE_PASSWORD: 21,
    CLIENT_ACCESS_LOG: 22,
    CLIENT_REPORTS: 23,
    CLIENT_HELP: 24,
    CLIENT_TEMPLATES: 25,
    CLIENT_USER_MANAGEMENT: 26,
    COMMUNICATION: 27,

    BEHAVIOUR_MONITORING_ACQUISITION: 28,
    BEHAVIOUR_MONITORING_RETENTION: 29,
    BEHAVIOUR_MONITORING_CREDIT_MONITORING: 30,
    BEHAVIOUR_MONITORING_PRE_MOVER: 76,
    BEHAVIOUR_MONITORING_PRE_MOVER_CONTACT: 77,
    BEHAVIOUR_MONITORING_PRE_MOVER_LIST: 78,
    BEHAVIOUR_MONITORING_NEW_MOVER: 79,
    BEHAVIOUR_MONITORING_NEWLY_MARRIED: 80,
    BEHAVIOUR_MONITORING_NEWLY_SINGLE: 81,
    BEHAVIOUR_MONITORING_PRENATAL: 82,
    BEHAVIOUR_MONITORING_NEW_BABY: 83,
    BEHAVIOUR_MONITORING_MORTGAGE_INTENT: 84,
    BEHAVIOUR_MONITORING_NEWLY_ENGAGED: 85,

    AUTO_RESPONSE_COMMUNICATION_ACQUISITION: 31,
    AUTO_RESPONSE_COMMUNICATION_RETENTION: 32,
    AUTO_RESPONSE_COMMUNICATION_CREDIT_MONITORING: 33,
    AUTO_RESPONSE_COMMUNICATION_PRE_MOVER: 66,
    AUTO_RESPONSE_COMMUNICATION_PRE_MOVER_CONTACT: 67,
    AUTO_RESPONSE_COMMUNICATION_PRE_MOVER_LIST: 68,
    AUTO_RESPONSE_COMMUNICATION_NEW_MOVER: 69,
    AUTO_RESPONSE_COMMUNICATION_NEWLY_MARRIED: 70,
    AUTO_RESPONSE_COMMUNICATION_NEWLY_SINGLE: 71,
    AUTO_RESPONSE_COMMUNICATION_PRENATAL: 72,
    AUTO_RESPONSE_COMMUNICATION_NEW_BABY: 73,
    AUTO_RESPONSE_COMMUNICATION_MORTGAGE_INTENT: 74,
    AUTO_RESPONSE_COMMUNICATION_NEWLY_ENGAGED: 75,


    // MANAGE_LO:34,
    SUB_ACCOUNT: 34,
    STIKKUM_BI: 35,
    STIKKUM_LO: 36,
    INTEGRATION: 37,
    PARTNER_DASHBOARD: 38,
    PARTNER_PROFILE: 40,
    PARTNER_REPORT: 39,
    PARTNER_USER_MANAGEMENT: 41,
    PARTNER_REFERRALS: 42,
    CLIENTS_SETTING: 43,
    LEADS_LISTING: 44,
    LEAD_PROFILE: 45,
    ADD_DATABASE_MANAGEment: 17,
    MARKET_PLACE: 52,
    ALTAIRDASHBOARD: 53,
    CHANGE_PLANE: 54,
    ALTAIR_MANAGEMENT: 55,
}

const ACTION = {
    ADD: 1,
    EDIT: 2,
    VIEW: 3,
    DELETE: 4,
    SEARCH: 5,
    LOGIN: 6,
    APPROVEDECLINE: 7,
    UPLOAD: 8,
    DOWNLOAD: 9,
    BRANCH: 10,
    COMMUNICATE: 11,
    SELFPULL: 12,
    PRIMARY: 13,
    GENERATELINK: 14,
    SHARELINK: 15,
    SENDEMAIL: 16,
    SENDSMS: 17,
    REQUESTDOC: 18,
    LOGS: 19,
    FILTER: 20,
    RESENDLINK: 21,
    REPORTS: 22,
    LO: 23,
    SNOOZE: 24,
    COPY: 25,
    ALL: 31,
    SUBSCRIBE: 27,
    SEND_SEQUENCE: 28,
    STOP_ALL_SEQUENCE_CAMPAIGN: 29,
    UNSUBSCRIBE: 30,
    PUSH_TO_OTHER_DATABASE: 32,
    UNDO_SNOOZE: 33,
    EMAIL_COMMUNICATE: 34,
    SMS_COMMUNICATE: 35,
}

const PERMISSION = {
    HELP_CONDITION: 1,
    PREFERENCE: 2,
    TEMPLATE: 3,
    USER_MANAGEMENT_LIST: 4,
    LEAD_LIST: 5,
    UPLOAD_DATABASE: 6,
    DATABASE_MANAGEMENT: 7,
    VIEW_LEAD_PROFILE: 8,
    CLIENT_DASHBOARD: 9,
    CLIENT_ALERT_DASHBOARD: 10,
    STIKKUM_BI: 11,
    STIKKUM_LO: 12,
    INTEGRATION: 13,
    BEHAVIOUR_MONITORING: 14,
    BEHAVIOUR_MONITORING_ACQUISITION: 15,
    BEHAVIOUR_MONITORING_RETENTION: 16,
    BEHAVIOUR_MONITORING_CREDIT_MONITORING: 17,
    AUTO_RESPONSE_COMMUNICATION: 18,
    AUTO_RESPONSE_COMMUNICATION_ACQUISITION: 19,
    AUTO_RESPONSE_COMMUNICATION_RETENTION: 20,
    AUTO_RESPONSE_CREDIT_MONITORING: 21,
    LIST_CLIENT: 22,
    VIEW_CLIENT: 23,
    LO_LISTING: 24,
    LIST_PARTNER: 25,
    VIEW_PARTNER: 26,
    LIST_LINK: 27,
    REFERRED_CLIENT: 28,
    PAYMENT_INFO: 29,
    ADMIN_PRICING: 30,
    LIST_PROMOTION: 31,
    COMMUNICATION_LOG: 32,
    VIEW_REPORT: 33,
    ADMIN_DASHBOARD: 34,
    CLIENTS_SETTING: 35,
    MARKET_PLACE: 36,
    SUB_ACCOUNT: 37,
    CHANGE_PLANE: 38
}

const ROLE_NAME = {
    ADMIN: 'STIKKUM ADMIN',
    CLIENT: 'STIKKUM CLIENT',

}

export {
    MODULE,
    SUBMODULE,
    ROLE_NAME,
    ACTION,
    PERMISSION
}